"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingProps = exports.SocialLinkProps = exports.SearchEngineOptimisationProps = exports.PetSureFooterDisclosureStatementProps = exports.HeaderProps = exports.FooterSectionProps = exports.FooterProps = exports.BrandDefinitionProps = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrandDefinitionProps = exports.BrandDefinitionProps = _propTypes.default.shape({
  key: _propTypes.default.string,
  title: _propTypes.default.string,
  homeUrl: _propTypes.default.string,
  cssUrls: _propTypes.default.arrayOf(_propTypes.default.string)
});
const SearchEngineOptimisationProps = exports.SearchEngineOptimisationProps = _propTypes.default.shape({
  title: _propTypes.default.string,
  description: _propTypes.default.string
});
const TrackingProps = exports.TrackingProps = _propTypes.default.shape({
  provider: _propTypes.default.string,
  key: _propTypes.default.string,
  keyValue: _propTypes.default.string
});
const SocialLinkProps = exports.SocialLinkProps = {
  icon: _propTypes.default.string,
  label: _propTypes.default.string,
  url: _propTypes.default.string,
  href: _propTypes.default.string,
  svg: _propTypes.default.element
};
const FooterSectionProps = exports.FooterSectionProps = _propTypes.default.shape({
  heading: _propTypes.default.string,
  content: _propTypes.default.element,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }))
});
const PetSureFooterDisclosureStatementProps = exports.PetSureFooterDisclosureStatementProps = {
  brandKey: _propTypes.default.string,
  brand: _propTypes.default.object,
  pds: _propTypes.default.object,
  tmd: _propTypes.default.object,
  vetChatTAndC: _propTypes.default.object,
  vetChatSignUp: _propTypes.default.object,
  authorisedRepresentative: _propTypes.default.string,
  expireDate: _propTypes.default.string,
  discount: _propTypes.default.number,
  hasExtraVetChatDescription: _propTypes.default.bool,
  hasGapOnly: _propTypes.default.bool,
  hasPetScripts: _propTypes.default.bool,
  additionParagraph: _propTypes.default.any
};
const FooterProps = exports.FooterProps = {
  brandKey: _propTypes.default.string,
  customContent: _propTypes.default.element,
  customCssClass: _propTypes.default.string,
  socialLinks: _propTypes.default.arrayOf(_propTypes.default.shape(SocialLinkProps)),
  copyright: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  customDisclosure: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element, _propTypes.default.shape(PetSureFooterDisclosureStatementProps)]),
  footerSections: _propTypes.default.arrayOf(FooterSectionProps)
};
const HeaderProps = exports.HeaderProps = {
  logoImageUrl: _propTypes.default.string,
  logoHoverText: _propTypes.default.string,
  logoRedirectUrl: _propTypes.default.string,
  pageTitleText: _propTypes.default.string,
  customContent: _propTypes.default.element,
  customCssClass: _propTypes.default.string,
  headerShouldPin: _propTypes.default.bool,
  contactDetails: _propTypes.default.element
};